import axios from "@/utils/axios";

export const login = async (credentials) => {
  localStorage.clear();
  const response = await axios.post("/login", credentials);
  const data = response.data;
  localStorage.setItem("access_token", data.access_token);
  localStorage.setItem("permissions", JSON.stringify(data.permissions || []));
  return response.data;
  
};

export const requestPasswordReset = async (email) => {
  const response = await axios.post("/forgot-password", { email });
  return response.data;
};

export const resetPassword = async (payload) => {
  const response = await axios.post("/reset-password", payload);
  return response.data;
};

export const logout = async () => {
  try {
    await axios.post("/logout");
  } catch (e) {
    // Optionally handle error
  }
  localStorage.removeItem("access_token");
  localStorage.removeItem("permissions");
};

export const getCurrentUser = () => {
  const token = localStorage.getItem("access_token");
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
};
